import { ReactNode, SyntheticEvent } from 'react';
import { CheckboxVariant } from 'core/flow/entities';
import { Checkbox } from '../../Checkbox';
import { FormControlLabel } from '../../FormControlLabel';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import { CheckboxIconStyled, ImageStyled } from './styled';

type CheckboxImageProps = {
  checked: boolean;
  value: string;
  imageSrc?: string;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
  disabled?: boolean;
};

const uncheckedIcon = <CheckboxIconStyled />;
const checkedIcon = (
  <CheckboxIconStyled $checked>
    <Icon name="ic-check" width={20} height={20} />
  </CheckboxIconStyled>
);

export const CheckboxImage = ({
  checked,
  value,
  onAnswerClick,
  children,
  imageSrc,
  disabled,
  ...otherProps
}: CheckboxImageProps) => {
  const onChange = (event: SyntheticEvent<Element, Event>, selected: boolean) => {
    onAnswerClick((event.target as HTMLInputElement).value, selected);
  };
  return (
    <>
      <FormControlLabel
        control={<Checkbox icon={uncheckedIcon} checkedIcon={checkedIcon} />}
        disableTypography
        label={imageSrc ? <ImageStyled fill src={imageSrc} alt="" /> : null}
        checked={checked}
        onChange={onChange}
        value={value}
        variant={CheckboxVariant.IMAGE}
        disabled={disabled}
        {...otherProps}
      />
      <Typography variant="text-body-sm">{children}</Typography>
    </>
  );
};
